/*
 * The class is responsible for redirection to login page after certain amount of seconds. It is used
 * in lessons page.
 * */
export class CourseInactivityRedirect {
    idleTimeout: number;
    idleDurationSeconds: number;

    constructor(idleDurationSeconds: number) {
        this.idleDurationSeconds = idleDurationSeconds;
    }

    resetIdleTimeout() {
        const secs = this.idleDurationSeconds * 1000;
        if (this.idleTimeout !== null) {
            window.clearTimeout(this.idleTimeout);
        }
        this.idleTimeout = window.setTimeout(() => {
            location.href = 'Login.aspx';
        }, secs);
    }

    init() {
        if (this.idleDurationSeconds < 1) {
            return;
        }
        console.log(`Start lesson inactivity timer ${this.idleDurationSeconds}.`);

        // Key events for reset time.
        this.resetIdleTimeout();
        window.onmousemove = this.resetIdleTimeout.bind(this);
        window.onkeypress = this.resetIdleTimeout.bind(this);
        window.onclick = this.resetIdleTimeout.bind(this);
        window.ontouchstart = this.resetIdleTimeout.bind(this);
        window.onfocus = this.resetIdleTimeout.bind(this);
        window.onchange = this.resetIdleTimeout.bind(this);
        window.onmouseover = this.resetIdleTimeout.bind(this);
        window.onmouseout = this.resetIdleTimeout.bind(this);
        window.onmousedown = this.resetIdleTimeout.bind(this);
        window.onmouseup = this.resetIdleTimeout.bind(this);
        window.onkeypress = this.resetIdleTimeout.bind(this);
        window.onkeydown = this.resetIdleTimeout.bind(this);
        window.onkeyup = this.resetIdleTimeout.bind(this);
        window.onsubmit = this.resetIdleTimeout.bind(this);
        window.onreset = this.resetIdleTimeout.bind(this);
        window.onselect = this.resetIdleTimeout.bind(this);
        window.onscroll = this.resetIdleTimeout.bind(this);
    }
}
